import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0ece4a2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "¡Sección de Webinars!", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Esta sección está destinada a resolver dudas", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"15px","width":"60%","margin-top":"0"} }, " Para mejorar tu formación, es esencial abordar las diferentes dudas que puedan surgir durante el proceso de aprendizaje.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "video-container" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    src: "https://player.vimeo.com/video/XXXXXXXXX",
    frameborder: "0",
    allowfullscreen: ""
  })
], -1))
const _hoisted_6 = { class: "session-cards" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Sesión 0", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Sesión 1", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Sesión 2", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Sesión 3", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Sesión 4", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Sesión 5", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 0,
  class: "descriptions"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import DefaultLayout from '@/layouts/DefaultLayout.vue';
import ProdevValidator from '@/components/auth/ProdevValidator.vue';
import { ref,Ref } from 'vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'WebinarDetailsView',
  setup(__props) {

let selectedSessionIndex = ref(-1);

const toogleDescription = (index: number) => {
  description.value = !description.value;
  selectedSessionIndex.value = index;
};


const titles:Ref<Array<string>> = ref(['Descripción sesión 0', 'Descripción sesión 1','Descripción sesión 2',
  'Descripción sesión 3','Descripción sesión 4' ,'Descripción sesión 5'])

const bodySession:Ref<Array<string>> = ref([
  'Descripción 0',
  'Descripción 1',
  'Descripción 2',
  'Descripción 3',
  'Descripción 4',
  'Descripción 5',

])  
const description = ref(false)




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _createVNode(ProdevValidator),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "session-card",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (toogleDescription(0)))
          }, _hoisted_8),
          _createElementVNode("div", {
            class: "session-card",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (toogleDescription(1)))
          }, _hoisted_10),
          _createElementVNode("div", {
            class: "session-card",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (toogleDescription(2)))
          }, _hoisted_12),
          _createElementVNode("div", {
            class: "session-card",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (toogleDescription(3)))
          }, _hoisted_14),
          _createElementVNode("div", {
            class: "session-card",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (toogleDescription(4)))
          }, _hoisted_16),
          _createElementVNode("div", {
            class: "session-card",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (toogleDescription(5)))
          }, _hoisted_18)
        ]),
        (description.value == true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("h2", null, _toDisplayString(titles.value[_unref(selectedSessionIndex)]), 1),
              _hoisted_21,
              _createElementVNode("p", null, _toDisplayString(bodySession.value[_unref(selectedSessionIndex)]), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})